import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function DashboardPlaceholder() {
	const { t } = useTranslation('common')

	const randomMessage = useMemo(() => {
		const index = Math.floor(Math.random() * 20)
		return t(`dashboard.placeholder_${index}`)
	}, [t])

	return (
		<div className="bg-[#251C4119] w-full flex items-center justify-center rounded-2xl ring ring-white/20">
			<div
				className="text-sm text-white px-[20%] text-center select-none"
				style={{ textShadow: '0 1px 1px rgba(0, 0, 0, 0.13)' }}
			>
				{randomMessage}
			</div>
		</div>
	)
}
